import React, { useState } from "react"
import {
  Button,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap"

const ATTACHMENT_TYPES = [
  { label: "Spreadsheet", value: "SPREADSHEET" },
  { label: "Spreadsheet (Multi-Line-Item)", value: "SPREADSHEET_REFMULTI" },
]

const AttachmentBox = ({ attachment, setAttachment, isEdit }) => {
  const [showModal, setShowModal] = useState(false)
  const [selectedType, setSelectedType] = useState("SPREADSHEET")
  const [selectedFile, setSelectedFile] = useState(null)
  const [fileError, setFileError] = useState(null)

  const openModal = () => {
    setSelectedType(attachment?.attachment_type || "SPREADSHEET")
    setSelectedFile(null)
    setFileError(null)
    setShowModal(true)
  }

  const closeModal = () => setShowModal(false)

  const handleFileChange = e => {
    setSelectedFile(e.target.files[0] || null)
    setFileError(null)
  }

  const handleSave = () => {
    if (!selectedFile) {
      setFileError("Please select a file.")
      return
    }
    const reader = new FileReader()
    reader.onload = e => {
      const base64 = e.target.result.split(",")[1]
      setAttachment({
        attachment_type: selectedType,
        attachment_template: base64,
        filename: selectedFile.name,
      })
      closeModal()
    }
    reader.readAsDataURL(selectedFile)
  }

  return (
    <>
      <Modal isOpen={showModal} toggle={closeModal}>
        <ModalHeader toggle={closeModal}>Add Attachment Template</ModalHeader>
        <ModalBody>
          <Row className="mb-3">
            <Label className="col-sm-4 col-form-label">Attachment Type</Label>
            <Col sm={8}>
              <Input
                type="select"
                value={selectedType}
                onChange={e => setSelectedType(e.target.value)}
              >
                {ATTACHMENT_TYPES.map(opt => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Input>
            </Col>
          </Row>
          <Row className="mb-3">
            <Label className="col-sm-4 col-form-label">Template File</Label>
            <Col sm={8}>
              <Input
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileChange}
              />
              {fileError && (
                <div className="text-danger mt-1">{fileError}</div>
              )}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSave}>
            Save
          </Button>
          <Button color="secondary" onClick={closeModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Row>
        <Label className="col-sm-2 col-form-label">Attachment Template</Label>
        <Col md={10}>
          {attachment ? (
            <div className="d-flex align-items-center mb-1">
              <span className="text-muted me-2">
                {attachment.attachment_type}
                {attachment.filename ? ` — ${attachment.filename}` : " (existing)"}
              </span>
              {isEdit && (
                <i
                  className="mdi mdi-trash-can font-size-16 text-danger"
                  style={{ cursor: "pointer" }}
                  onClick={() => setAttachment(null)}
                />
              )}
            </div>
          ) : (
            <div className="text-muted mb-1">No attachment template added.</div>
          )}
          {isEdit && (
            <Button
              type="button"
              className="btn btn-sm"
              color="primary"
              onClick={openModal}
            >
              {attachment ? "Replace Attachment Template" : "Add Attachment Template"}
            </Button>
          )}
        </Col>
      </Row>
    </>
  )
}

export default AttachmentBox
